import { render, staticRenderFns } from "./zgh.vue?vue&type=template&id=34d110b7&scoped=true"
import script from "./zgh.vue?vue&type=script&lang=js"
export * from "./zgh.vue?vue&type=script&lang=js"
import style0 from "./zgh.vue?vue&type=style&index=0&id=34d110b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d110b7",
  null
  
)

export default component.exports